// extracted by mini-css-extract-plugin
export var wordContainer = "_mf-0";